import { render, staticRenderFns } from "./PlayoffScoreCard.vue?vue&type=template&id=56eda9f4&scoped=true&"
import script from "./PlayoffScoreCard.vue?vue&type=script&lang=js&"
export * from "./PlayoffScoreCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayoffScoreCard.vue?vue&type=style&index=0&id=56eda9f4&lang=scss&scoped=true&"
import style1 from "./PlayoffScoreCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eda9f4",
  null
  
)

export default component.exports